
export const GetQueryString = name => {
  var url = new RegExp("(^|[?#]|&)" + name + "=([^&]*)(&|$)");
  var newUrl = window.location.search.substr(1).match(url);
  if (newUrl != null) {
    return unescape(newUrl[2]);
  } else {
    return '';
  }
};

export const GetExtraQueryString = name => {
  // http://127.0.0.1:8080/?page=agent&orgId=2&srcCurrentOrgId=1749#/agent/agentSign?staffId=135674&xyz=123
  let res = {};
  let urlStr = window.location.hash;
  if (urlStr.includes('?')) {
    let urlArr = urlStr.split('?')[1];
    if (urlArr.includes('&')) {
      let s = urlArr.split('&');
      s.forEach(v => {
        let d = v.split('=');
        res[d[0]] = d[1];
      })
    } else {
      let s = urlArr.split('=');
      res[s[0]] = s[1];
    }
  }
  return res[name];
}

export const throttle = function (fn, delay, atleast) {
  var timer = null;
  var previous = null;

  return function () {
    var now = +new Date();

    if (!previous) previous = now;
    if (atleast && now - previous > atleast) {
      fn();
      // 重置上一次开始时间为本次结束时间
      previous = now;
      clearTimeout(timer);
    } else {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn();
        previous = null;
      }, delay);
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/urlData.js